import { PanelResult } from "common/panel/dto/PanelResult";
import styled from "styled-components";
import PanelSingleNav from "components/common/panel/PanelSingleNav";
import { Divider } from "@mui/material";
import NavLinkUndecorated from "components/common/style/link/NavLinkUndecorated";
import { panelLinkSingle } from "common/panel/panel_link_common";
import { dateFormatGet } from "common/date_common";
import { staticContentPath } from "common/static_content_common";
import PanelPlay from "components/common/panel/PanelPlay";

type PanelItemProps = {
  panel: PanelResult;
};

const PanelItem = ({ panel }: PanelItemProps) => {
  return (
    <Div>
      <Divider />
      <Div>
        <NavLinkUndecorated to={panelLinkSingle(panel.id)}>
          <div>{dateFormatGet(panel.datum)}</div>
          <div>{panel.title} </div>
          {panel.fileName && (
            <PanelPlay
              filePath={staticContentPath(panel.fileName)}
              autoPlay={false}
              muted={true}
              width={200}
            />
          )}
        </NavLinkUndecorated>
        <PanelSingleNav panel={panel} />
      </Div>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 2rem;
`;

export default PanelItem;
